<div class="content">
  @if (!resultVisible) {
    <app-skill class="main"></app-skill>
  }
  <app-recommendations class="side" [class.show-result]="resultVisible"></app-recommendations>
  <button class="floating-button" mat-flat-button (click)="toogleResult()" color="accent">
    @if (!resultVisible) {
      <span>Vorschläge anzeigen</span>
    }
    @if (resultVisible) {
      <span>Kompetenzprofil anzeigen</span>
    }
  </button>
</div>
